import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';

const EventStarted = ({ eventName }) => (
    <Styled.Wrapper>
        <Styled.Text>
            The <Styled.Highlighted>{eventName}</Styled.Highlighted> race is now{' '}
            <Styled.Highlighted>in-running</Styled.Highlighted>. Please check
            back later for the results.
        </Styled.Text>
    </Styled.Wrapper>
);

EventStarted.propTypes = {
    eventName: PropTypes.string.isRequired
};

export default EventStarted;
